
export const enum CLASS_SIZE {
	XS = 'size_xs',
	SM = 'size_sm',
	MD = 'size_md',
	LG = 'size_lg'
}

export const enum BORDER_GROUP_TYPE {
	ALONE = '',

	CENTER = '!rounded-none',

	TOP = '!rounded-b-none',
	BOTTOM = '!rounded-t-none',

	LEFT = '!rounded-r-none',
	RIGHT = '!rounded-l-none'
}